module.exports = __webpack_public_path__ + "static/media/pixellion-logo.085a8ac9.png";